/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PruefchecklisteDetail { 
    beschreibung?: string;
    pruefplan_id: string;
    titel?: string;
    ist_aktiv: boolean;
    pruefcheckliste_id: string;
    reihenfolge: number;
    mandant_id?: string;
    modified_on_utc?: Date;
}

